import React from 'react';
import {Tooltip} from '@/components/tooltips';
import {TooltipPlacement} from '@/components/tooltips/types';
import Icon from '@/components/icons/Icon';

interface FormHelpProps {
  content: React.ReactNode;
  type?: 'tooltip' | 'popover';
  placement?: TooltipPlacement;
  icon?: string;
  className?: string;
}

const FormHelp: React.FC<FormHelpProps> = ({
    content,
    placement = 'top',
    icon = 'mdi-information-outline',
    className = '',
}) => {
    const button = (
        <button
            type="button"
            className={`btn btn-link p-0 ml-1 ${className}`}
            style={{cursor: 'pointer', border: 'none', background: 'none'}}
            data-cy="help-btn">
            <Icon name={icon} size='xs' className={className} />
        </button>
    );

    return (
        <Tooltip
            content={typeof content === 'string' ? content : String(content)}
            placement={placement}
        >
            {button}
        </Tooltip>
    );
};

export default FormHelp;
